<template>
<div class="sticky-top mt-2">
  <nav class="navbar navbar-expand-lg navbar-light bg-primary rounded shadow-sm ">
    <div class="container-fluid">
      <button class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <form class="d-flex">
          <input
              class="form-control me-2"
              type="search"
              placeholder="Search" aria-label="Search">
          <button
              class="btn btn-outline-light"
              type="submit">Search</button>
        </form>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle text-white"
               href="#"
               id="navbarDropdown"
               role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
              <img src="../../assets/user_images/1.jpeg" alt="" class="user-image">
              User Name
            </a>
            <ul class="dropdown-menu mt-2" aria-labelledby="navbarDropdown">
              <Li title="Profile" link-name="profile" ></Li>
              <Li title="Setting" link-name="/" icon="fa-gear"></Li>
              <LiDivider></LiDivider>
              <Li title="Log Out" link-name="/" icon="fa-power-off"></Li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
</template>

<script>
import Li from "@/components/small_layouts/Li";
import LiDivider from "@/components/small_layouts/Li-Divider";
export default {
  name: "Nav",
  components: {LiDivider, Li}
}
</script>

<style scoped>
.user-image{
  width: 35px;
  height: 35px;
  border-radius: 50%;

}
</style>